import { Accordion, Link, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { handleContactTeam } from "shared-utils";
import { styled } from "styled-components";

import { HowItWorks } from "./how-it-works";
import { MESSAGES } from "./message-definitions";

const BoldText = styled.strong`
  font-weight: bold;
`;

export const SubsequentFundingFaq = () => {
  const intl = useIntl();

  const items = [
    { header: intl.formatMessage(MESSAGES.faqHowToApplyHeader), body: <HowItWorks /> },
    {
      header: intl.formatMessage(MESSAGES.faqWhoIsEligibleHeader),
      body: (
        <TextContainer>
          {intl.formatMessage(MESSAGES.faqWhoIsEligibleBody, {
            p: (chunks: any) => <Text>{chunks}</Text>,
            x: (chunks: any) => <Link onClick={handleContactTeam}>{chunks}</Link>,
          })}
        </TextContainer>
      ),
    },
    {
      header: intl.formatMessage(MESSAGES.faqHowLongHeader),
      body: intl.formatMessage(MESSAGES.faqHowLongBody, { b: (chunks: any) => <BoldText>{chunks}</BoldText> }),
    },
    {
      header: intl.formatMessage(MESSAGES.faqWhenReceiveFundsHeader),
      body: (
        <TextContainer>
          {intl.formatMessage(MESSAGES.faqWhenReceiveFundsBody, {
            p: (chunks: any) => <Text>{chunks}</Text>,
            b: (chunks: any) => <BoldText>{chunks}</BoldText>,
          })}
        </TextContainer>
      ),
    },
    {
      header: intl.formatMessage(MESSAGES.faqHelpHeader),
      body: intl.formatMessage(MESSAGES.faqHelpBody, {
        x: (chunks: any) => <Link onClick={handleContactTeam}>{chunks}</Link>,
      }),
    },
  ];
  return <Accordion items={items} />;
};
